import { FC, ReactElement } from 'react'
import { RewardStatus } from 'interfaces/bounty'
import { ModalStatusDescription } from 'components/features/pfm/RewardDetails/ModalStatusDescription'

type ModalProps = {
  onCloseClick: () => void
}

const STATUSES_CASH: Partial<Record<RewardStatus, string>> = {
  pending: 'Reward tracking was initiated. We’re confirming the fulfillment of the reward requirements. This may take up to 30 days.',
  confirmed: 'Your reward was confirmed. It may take up to 30 days to be added to your account.',
  earned: 'Your reward has been added to your account.',
  expired: 'We were unable to confirm the fulfillment of the reward requirements.',
}

export const ModalCash: FC<ModalProps> = ({
  onCloseClick,
}): ReactElement => {
  return (
    <ModalStatusDescription
      title='Tracking your reward’s progress'
      statuses={ STATUSES_CASH }
      onCloseClick={ onCloseClick }
    />
  )
}
